module.exports = __webpack_public_path__ + "img/advance6.922e9ca6.png";